import Dropdown from 'components/Form/Dropdown';
import FormActions from 'components/Form/FormActions';
import FormResult from 'components/Form/FormResult';
import SubmitButton from 'components/Form/SubmitButton';
import SideBySide from 'components/Layout/SideBySide';
import LinkButton from 'components/LinkButton';
import SectionHeader from 'components/SectionHeader';
import {FC} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {FormFields} from 'types/utils';
import {setUrl} from 'utils/request';
import {onApiError, onApiSuccess} from 'utils/request-axios/utils';

import {ProfileChangeOwnerRequest, usePostProfile} from './services';
import {ProfileChangeOwnerBackend} from './types';

type ProfileChangeOwnerFormData = FormFields<ProfileChangeOwnerRequest>;

const ChangeOwner: FC = () => {
    const {
        data: {employees},
    } = useBackend<ProfileChangeOwnerBackend>();

    const methods = useForm<ProfileChangeOwnerFormData>({
        defaultValues: {},
    });
    const {handleSubmit} = methods;

    const {mutateAsync} = usePostProfile();

    const onSubmit = async (formData: ProfileChangeOwnerFormData) => {
        mutateAsync(formData)
            .then(
                onApiSuccess({
                    onRedirect: (response) => {
                        if (response.name === 'employee_list_view') {
                            return setUrl(window.Urls.employee_list_view());
                        }
                        throw new Error('Invalid redirect response');
                    },
                }),
            )
            .catch(onApiError(methods));
    };

    const formDisabled = employees.length === 0;

    return (
        <FormProvider {...methods}>
            <SectionHeader
                subtitle={t`Transfer the ownership of this company to another user`}
                title={t`Transfer Ownership`}
            />
            <form onSubmit={handleSubmit(onSubmit)}>
                <SideBySide className="mt-4 max-w-xl">
                    <Dropdown
                        aria-label="Owner"
                        disabled={formDisabled}
                        helpText={t`Users must have a verified Primary Email address to become Owner.`}
                        label={t`Owner`}
                        name="owner"
                        options={employees}
                        required={true}
                        type="select"
                    />
                    <FormResult />
                    <FormActions align="left">
                        <LinkButton
                            href={window.Urls.employee_list_view()}
                            kind="tertiary"
                        >
                            {t`Cancel`}
                        </LinkButton>
                        <SubmitButton disabled={formDisabled}>
                            {t`Confirm`}
                        </SubmitButton>
                    </FormActions>
                </SideBySide>
            </form>
        </FormProvider>
    );
};

export default ChangeOwner;
